<div *ngIf="progressFacade.progressSearchSpinner$ | async" class="skeleton-table-container">
  <div class="skeleton-table">
    <div class="skeleton-header-row">
      <div class="skeleton-header-cell" *ngFor="let i of [1, 2, 3, 4, 5]"></div>
    </div>
    <div class="skeleton-row" *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]">
      <div class="skeleton-cell" *ngFor="let j of [1, 2, 3, 4, 5]"></div>
    </div>
  </div>
</div>
<div *ngIf="!(progressFacade.progressSearchSpinner$ | async)">
  <div *ngIf="facade.renderNoGridResults$ | async" class="grid-no-results">
    <div class="empty-state">
      <div class="empty-state-icon">
        <mat-icon>search_off</mat-icon>
      </div>
      <div class="empty-state-title">{{ systemLiterals.noResultsFound$ | async }}</div>
      <div class="empty-state-subtitle">
        Try adjusting your search filters or broadening your criteria
      </div>
    </div>
  </div>

  <div *ngIf="facade.renderGrid$ | async" class="grid-container">
    <dragonfly-paginator *ngIf="eliquaFacadeService.renderPaginator$ | async"></dragonfly-paginator>

    <div class="table-container mat-elevation-z0">
      <table mat-table class="table" [dataSource]="facade.gridData">
        <ng-container
          *ngFor="let column of facade.displayedColumns$ | async | keyvalue"
          [matColumnDef]="column.key"
        >
          <th mat-header-cell *matHeaderCellDef class="headers">
            <div
              *ngIf="
                column.key !== tagLiterals.tagEdit &&
                column.key !== tagLiterals.tagInactive &&
                column.key !== actions.BulkSearch &&
                column.key !== 'Bulk ' + bulkLiterals.bulkStatus &&
                column.key !== userLiterals.deleteFlag &&
                column.key !== 'UserMgmtEdit' &&
                column.key !== 'InvoicesActions' &&
                column.key !== invoiceLiterals.gridGrandTotal &&
                column.key !== invoiceLiterals.lineAmount &&
                column.key !== 'Inactive Group Templates' &&
                column.key !== 'Group Templates Actions' &&
                column.key !== 'Checkbooks Actions' &&
                column.key !== 'MerchantActions' &&
                column.key !== 'MerchantCouponActions' &&
                column.key !== 'MerchantStoresActions' &&
                column.key !== 'UserMgmtEdit' &&
                column.key !== 'ClubActive' &&
                column.key !== 'Clubs ' + this.clubLiteralsFacade.startDate &&
                column.key !== 'ClubActions' &&
                column.key !==
                  literalsFacade.literals.literals['liquid.merchant.search.merchantstatus'] &&
                column.key !== 'liquid.merchant.summary.storestatus' &&
                column.key !== this.bulkLiterals.integrationStatus &&
                column.key !== 'CampaignExecutions' &&
                column.key !== 'SearchLiteralsActions' &&
                column.key !== 'Is Selected File' &&
                column.key !== 'Is New Literal' &&
                column.key !== 'SchemasActive' &&
                column.key !== 'SchemasActions' &&
                column.key !== 'CardBatchesActions' &&
                column.key !== 'CardBatches_CreationDate' &&
                column.key !== 'CardBatches_PrintDate' &&
                column.key !== 'RedeemRulesActions' &&
                !column.key.startsWith('RR,') &&
                column.key !== 'FlowActions' &&
                column.key !== 'TicketsActions' &&
                column.key !== 'Ticket' + ticketsLiterals.ticketStatus &&
                column.key !== 'FlowStatus' &&
                column.key !== 'StoreStatus' &&
                column.key !== 'StoreActions' &&
                column.key !== 'FlowRecipesActions' &&
                column.key !== 'FlowRecipesStatus' &&
                column.key !== 'FlowRecipes,' + 'Recipe Type' &&
                column.key !== 'FlowRecipes,' + 'Recipe Name' &&
                column.key !==
                  'FlowRecipes,' +
                    this.literalsFacade.literals.literals['liquid.loyaltyrule.startdate'] &&
                column.key !==
                  'FlowRecipes,' +
                    this.literalsFacade.literals.literals['liquid.loyaltyrule.enddate'] &&
                column.key !== 'Store' + storeLiterals.storeName &&
                column.key !== 'CustomerActions' &&
                column.key !==
                  'Customer' + this.literalsFacade.literals.literals['liquid.schema'] &&
                column.key !== 'LMemberStatus' &&
                column.key !== 'ACStatus' &&
                column.key !== 'AllCustomerActions' &&
                column.key !== 'CampaignSearchActions' &&
                column.key !== 'CampaignSearchStatus' &&
                column.key !== 'CampaignSearch ' + campaignSearchLiterals.campaignSchema &&
                column.key !== 'CampaignSearch ' + campaignSearchLiterals.campaignStatus &&
                column.key !== 'CampaignSearch ' + campaignSearchLiterals.campaignCategory &&
                column.key !== 'CampaignSearch ' + campaignSearchLiterals.campaignCountry &&
                column.key !== 'CampaignSearch ' + campaignSearchLiterals.campaignChannel &&
                column.key !== 'CampaignSearch ' + campaignSearchLiterals.campaignTarget
              "
            >
              {{ column.key }}
            </div>

            <div *ngIf="column.key === invoiceLiterals.gridGrandTotal">
              {{ column.key }}
              <mat-icon
                fontIcon="help"
                class="field-helper"
                [matTooltip]="invoiceLiterals.getGrandTotalTooltip$ | async"
              ></mat-icon>
            </div>

            <div *ngIf="column.key === invoiceLiterals.lineAmount">
              {{ column.key }}
              <mat-icon
                fontIcon="help"
                class="field-helper"
                [matTooltip]="invoiceLiterals.getAmountTooltip$ | async"
              ></mat-icon>
            </div>

            <div *ngIf="column.key === 'Bulk ' + bulkLiterals.bulkStatus">
              {{ column.key.split(' ')[1] }}
            </div>
            <div *ngIf="column.key === 'FlowRecipes,' + 'Recipe Type'">
              {{ column.key.split(',')[1] }}
            </div>
            <div *ngIf="column.key === 'FlowRecipes,' + 'Recipe Name'">
              {{ column.key.split(',')[1] }}
            </div>
            <div
              *ngIf="
                column.key ===
                'FlowRecipes,' +
                  this.literalsFacade.literals.literals['liquid.loyaltyrule.startdate']
              "
            >
              {{ column.key.split(',')[1] }}
            </div>
            <div
              *ngIf="
                column.key ===
                'FlowRecipes,' + this.literalsFacade.literals.literals['liquid.loyaltyrule.enddate']
              "
            >
              {{ column.key.split(',')[1] }}
            </div>
            <div *ngIf="column.key === 'Clubs ' + this.clubLiteralsFacade.startDate">
              Start Date
            </div>

            <div *ngIf="column.key === 'CardBatches_CreationDate'">Creation Date</div>
            <div *ngIf="column.key === 'CardBatches_PrintDate'">Print Date</div>

            <div
              *ngIf="
                column.key === 'Customer' + this.literalsFacade.literals.literals['liquid.schema']
              "
            >
              {{ this.literalsFacade.literals.literals['liquid.schema'] }}
            </div>

            <div *ngIf="column.key === 'Ticket' + ticketsLiterals.ticketStatus">
              {{ ticketsLiterals.ticketStatus }}
            </div>

            <div *ngIf="column.key === 'Store' + storeLiterals.storeName">
              {{ storeLiterals.storeName }}
            </div>

            <div *ngIf="column.key.startsWith('RR,')">
              {{ column.key.split(',')[1] }}
            </div>

            <div *ngIf="column.key === 'CampaignSearch ' + campaignSearchLiterals.campaignSchema">
              {{ column.key.split(' ')[1] }}
            </div>

            <div *ngIf="column.key === 'CampaignSearch ' + campaignSearchLiterals.campaignStatus">
              {{ column.key.split(' ')[1] }}
            </div>

            <div *ngIf="column.key === 'CampaignSearch ' + campaignSearchLiterals.campaignCategory">
              {{ column.key.split(' ')[1] }}
            </div>

            <div *ngIf="column.key === 'CampaignSearch ' + campaignSearchLiterals.campaignCountry">
              {{ column.key.split(' ')[1] }}
            </div>

            <div *ngIf="column.key === 'CampaignSearch ' + campaignSearchLiterals.campaignChannel">
              {{ column.key.split(' ')[1] }}
            </div>

            <div *ngIf="column.key === 'CampaignSearch ' + campaignSearchLiterals.campaignTarget">
              {{ column.key.split(' ')[1] }}
            </div>
          </th>

          <td mat-cell *matCellDef="let element; let index = index">
            <div [ngSwitch]="column.key">
              <div *ngSwitchCase="tagLiterals.tagEdit">
                <button
                  mat-flat-button
                  class="table-gray-button"
                  [disabled]="updateTagFacadeService.updateTagDisabled$ | async"
                  [matTooltip]="tagLiterals.tagUpdate$ | async"
                  [matTooltipPosition]="'above'"
                  (click)="editData(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon>edit</mat-icon>
                </button>
              </div>

              <div *ngSwitchCase="tagLiterals.tagInactive">
                <mat-icon
                  [matTooltip]="
                    element.inactive
                      ? (tagLiterals.isInactive$ | async)
                      : (tagLiterals.isActive$ | async)
                  "
                  [ngClass]="{
                    active: !element.inactive,
                    inactive: element.inactive,
                  }"
                  >fiber_manual_record</mat-icon
                >
              </div>

              <div
                *ngSwitchCase="
                  [tagLiterals.tagStartDate, tagLiterals.tagEndDate].includes(column.key)
                    ? column.key
                    : !column.key
                "
                class="table-cell"
              >
                <div class="date-text">
                  {{ element[column.value].split('T')[0] | date: 'dd-MM-yyyy' }}
                </div>

                <button
                  *ngIf="editDateFacadeService.editDateDisabled$ | async"
                  mat-flat-button
                  class="table-gray-button"
                  (click)="
                    editData(element, column.key, column.value); stopRowDataFlow($event, element)
                  "
                >
                  <mat-icon>edit</mat-icon>
                </button>
              </div>

              <div
                *ngSwitchCase="
                  'FlowRecipes,' +
                  this.literalsFacade.literals.literals['liquid.loyaltyrule.startdate']
                "
                class="table-cell"
              >
                <div class="date-text">
                  {{ element[column.value]?.split('T')[0] | date: 'dd-MM-yyyy' }}
                </div>
              </div>

              <div
                *ngSwitchCase="
                  'FlowRecipes,' +
                  this.literalsFacade.literals.literals['liquid.loyaltyrule.enddate']
                "
                class="table-cell"
              >
                <div class="date-text">
                  {{ element[column.value]?.split('T')[0] | date: 'dd-MM-yyyy' }}
                </div>
              </div>
              <div *ngSwitchCase="'FlowRecipes,' + 'Recipe Type'" class="table-cell">
                <div class="date-text">
                  {{ element[column.value] }}
                </div>
              </div>
              <div *ngSwitchCase="'FlowRecipes,' + 'Recipe Name'" class="table-cell">
                <div class="date-text">
                  {{ element[column.value] }}
                </div>
              </div>

              <div *ngSwitchCase="'FlowRecipesStatus'" class="table-cell">
                <mat-icon
                  [matTooltip]="
                    element.deleteFlag
                      ? (recipesLiterals.deleted$ | async)
                      : (recipesLiterals.active$ | async)
                  "
                  [ngClass]="{
                    active: !element.deleteFlag,
                    inactive: element.deleteFlag,
                  }"
                  >fiber_manual_record</mat-icon
                >
              </div>

              <div
                *ngSwitchCase="
                  this.literalsFacade.literals.literals['liquid.integrations.integrationactions']
                "
              >
                <button
                  *ngIf="integrationManagementActionsFacadeService.updateBtnEnabled$ | async"
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="
                    element.deleted
                      ? literalsFacade.literals.literals['liquid.merchant.summary.activate']
                      : literalsFacade.literals.literals['liquid.merchant.summary.deactivate']
                  "
                  [matTooltipPosition]="'above'"
                  (click)="changeRowStatus(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon
                    [ngClass]="{
                      'text-active': !element.deleted,
                      'text-inactive': element.deleted,
                    }"
                    >power_settings_new</mat-icon
                  >
                </button>
                <button
                  *ngIf="integrationManagementActionsFacadeService.showEditBtn[index]"
                  mat-flat-button
                  class="table-gray-button"
                  matTooltip="Edit"
                  [matTooltipPosition]="'above'"
                  (click)="editData(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  *ngIf="integrationManagementActionsFacadeService.deleteBtnEnabled$ | async"
                  mat-flat-button
                  class="table-gray-button"
                  matTooltip="Delete"
                  [matTooltipPosition]="'above'"
                  (click)="deleteRowData(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>

              <div *ngSwitchCase="actions.BulkSearch">
                <button
                  mat-flat-button
                  class="table-gray-button"
                  [disabled]="element.deleteFlag"
                  [matTooltip]="bulkLiterals.newBulkOperation$ | async"
                  [matTooltipPosition]="'above'"
                  (click)="newBulkOperation(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon
                    class="bulk"
                    [ngClass]="{
                      'new-operation-disabled': element.deleteFlag,
                    }"
                    >arrow_circle_up</mat-icon
                  >
                </button>
                <button
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="'Edit'"
                  [matTooltipPosition]="'above'"
                  (click)="editData(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="element.deleteFlag ? 'Mark as Active' : 'Mark as Inactive'"
                  [matTooltipPosition]="'above'"
                  (click)="changeRowStatus(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon
                    [ngClass]="{
                      'text-active': !element.deleteFlag,
                      'text-inactive': element.deleteFlag,
                    }"
                    >power_settings_new</mat-icon
                  >
                </button>
              </div>

              <div *ngSwitchCase="this.bulkLiterals.integrationStatus">
                <mat-icon
                  [matTooltip]="
                    element[column.value]
                      ? this.literalsFacade.literals.literals['liquid.integrations.filter.inactive']
                      : this.literalsFacade.literals.literals['liquid.integrations.filter.active']
                  "
                  [ngClass]="{
                    active: !element[column.value],
                    inactive: element[column.value],
                  }"
                  >fiber_manual_record</mat-icon
                >
              </div>

              <div *ngSwitchCase="'Bulk ' + bulkLiterals.bulkStatus">
                <div *ngIf="!element[column.value]" class="bulk-complete">
                  <mat-icon class="bulk-status-icon">done</mat-icon> Complete
                </div>
                <div *ngIf="element[column.value]" class="bulk-in-progress">
                  <mat-spinner class="bulk-spinner"> </mat-spinner>
                  {{ bulkLiterals.bulkInProgress }}
                </div>
              </div>

              <div *ngSwitchCase="bulkLiterals.bulkImportDate$ | async">
                <div>
                  {{ element[column.value].split('.')[0].split('T')[0] }}
                  {{ element[column.value].split('.')[0].split('T')[1] }}
                </div>
              </div>

              <div *ngSwitchCase="'Errors'">
                <div *ngIf="element[column.value]">
                  <button
                    mat-stroked-button
                    class="bulk-error-btn"
                    (click)="
                      editData(element, column.key, column.value); stopRowDataFlow($event, element)
                    "
                  >
                    {{ bulkLiterals.errorsFound$ | async }}
                    {{ element[column.value] }}
                  </button>
                </div>
              </div>

              <div *ngSwitchCase="userLiterals.deleteFlag">
                <mat-icon
                  fontIcon="fiber_manual_record"
                  [ngClass]="{
                    active: !element.deleteFlag,
                    inactive: element.deleteFlag,
                  }"
                  [matTooltip]="element.deleteFlag ? 'Deactivated' : 'Active'"
                  [matTooltipPosition]="'above'"
                ></mat-icon>
              </div>

              <div *ngSwitchCase="'UserMgmtEdit'">
                <button
                  mat-flat-button
                  class="table-gray-button"
                  matTooltip="Edit"
                  [matTooltipPosition]="'above'"
                  (click)="editData(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon>edit</mat-icon>
                </button>
              </div>

              <div *ngSwitchCase="invoiceLiterals.creationDate">
                <div *ngIf="eliquaFacadeService.activeComponent === 'InvoicesComponent'">
                  {{ matchRowWithColumn(element, column.value) | date: 'dd/MM/yyyy' }}
                </div>
              </div>

              <div *ngSwitchCase="invoiceLiterals.gridInvoiceDate">
                {{ matchRowWithColumn(element, column.value) | date: 'dd/MM/yyyy' }}
              </div>

              <div *ngSwitchCase="invoiceLiterals.invoiceTime">
                {{ matchRowWithColumn(element, column.value) | date: 'HH:mm:ss' }}
              </div>

              <div *ngSwitchCase="invoiceLiterals.returnPurchase">
                <div *ngIf="matchRowWithColumn(element, column.value)">
                  {{ invoiceLiterals.return$ | async }}
                </div>
                <div *ngIf="!matchRowWithColumn(element, column.value)">
                  {{ invoiceLiterals.purchase$ | async }}
                </div>
              </div>

              <div *ngSwitchCase="invoiceLiterals.Store">
                {{ filterInvoiceStore(element, column.value) }}
              </div>

              <div *ngSwitchCase="invoiceLiterals.gridGrandTotal">
                {{ matchRowWithColumn(element, column.value) + element['tableCurrencySymbol'] }}
              </div>

              <div *ngSwitchCase="invoiceLiterals.lineAmount">
                {{ matchRowWithColumn(element, column.value) + element['tableCurrencySymbol'] }}
              </div>

              <div *ngSwitchCase="'InvoicesActions'" class="column-nowrap">
                <button
                  *ngIf="invoicesFacade.viewDetailsRole$ | async"
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="literalsFacade.literals.literals['liquid.invoice.details']"
                  [matTooltipPosition]="'above'"
                  (click)="openInvoiceDetails(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon class="invoices-button" fontIcon="visibility"></mat-icon>
                </button>
                <button
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="literalsFacade.literals.literals['liquid.invoice.profile']"
                  [matTooltipPosition]="'above'"
                  (click)="summaryRedirect(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon class="invoices-button" fontIcon="person"></mat-icon>
                </button>
                <button
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="literalsFacade.literals.literals['liquid.invoice.deleteinvoice']"
                  [matTooltipPosition]="'above'"
                  [disabled]="invoicesFacade.canDeleteInvoiceRole$ | async"
                  (click)="deleteInvoice(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon class="invoices-button" fontIcon="delete_outline"></mat-icon>
                </button>
                <button
                  *ngIf="element.couponList.length"
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="literalsFacade.literals.literals['liquid.invoice.showcoupons']"
                  [matTooltipPosition]="'above'"
                  (click)="openInvoiceCoupons(element); stopRowDataFlow($event, element)"
                >
                  <div class="percent-custom-icon">%</div>
                </button>
                <button
                  *ngIf="element.attributes"
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="literalsFacade.literals.literals['liquid.invoice.showattributes']"
                  [matTooltipPosition]="'above'"
                  (click)="openInvoiceAttributes(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon class="invoices-button" fontIcon="info"></mat-icon>
                </button>
              </div>

              <div
                *ngSwitchCase="
                  literalsFacade.literals.literals['liquid.merchant.search.merchantstatus']
                "
              >
                <mat-icon
                  fontIcon="fiber_manual_record"
                  [matTooltip]="
                    element.active
                      ? literalsFacade.literals.literals['liquid.merchant.summary.active']
                      : literalsFacade.literals.literals['liquid.merchant.summary.inactive']
                  "
                  [ngClass]="{
                    active: element.active,
                    inactive: !element.active,
                  }"
                ></mat-icon>
              </div>

              <div *ngSwitchCase="'MerchantActions'">
                <button
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="literalsFacade.literals.literals['liquid.merchant.tab.summary']"
                  [matTooltipPosition]="'above'"
                  (click)="merchantSummary(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon class="merchant">visibility</mat-icon>
                </button>
                <button
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="literalsFacade.literals.literals['liquid.merchant.tab.details']"
                  [matTooltipPosition]="'above'"
                  (click)="merchantDetails(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon class="merchant">edit</mat-icon>
                </button>
              </div>

              <div
                *ngSwitchCase="
                  literalsFacade.literals.literals['liquid.merchant.search.registrationfrom']
                "
                class="table-cell"
              >
                {{ element[column.value] | date: 'dd/MM/yyyy' }}
              </div>

              <div *ngSwitchCase="'liquid.merchant.summary.storestatus'">
                <mat-icon
                  fontIcon="fiber_manual_record"
                  [ngClass]="{
                    active: !element.inactive,
                    inactive: element.inactive,
                  }"
                  [matTooltip]="element.inactive ? 'Deactivated' : 'Active'"
                  [matTooltipPosition]="'above'"
                ></mat-icon>
              </div>

              <div
                *ngSwitchCase="literalsFacade.literals.literals['liquid.merchant.creationdate']"
                class="table-cell"
              >
                <div *ngIf="eliquaFacadeService.activeComponent === 'MerchantSummaryComponent'">
                  {{ element[column.value] | date: 'dd/MM/yyyy' }}
                </div>
              </div>

              <div
                *ngSwitchCase="literalsFacade.literals.literals['liquid.merchant.summary.address']"
              >
                {{ matchMerchantStoreAddress(element, column.value) }}
              </div>

              <div *ngSwitchCase="'MerchantStoresActions'">
                <button
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="'edit'"
                  [matTooltipPosition]="'above'"
                  (click)="merchantEditStore(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon fontIcon="edit"></mat-icon>
                </button>
                <button
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="'Unbind store'"
                  [matTooltipPosition]="'above'"
                  (click)="merchantUnbindStore(); stopRowDataFlow($event, element)"
                >
                  <mat-icon fontIcon="domain_disabled"></mat-icon>
                </button>
                <button
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="element.inactive ? 'Activate' : 'Deactivate'"
                  [matTooltipPosition]="'above'"
                  (click)="merchantChangeStoreStatus(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon
                    fontIcon="power_settings_new"
                    [ngClass]="{
                      'club-active': !element.inactive,
                      'club-inactive': element.inactive,
                    }"
                  ></mat-icon>
                </button>
              </div>

              <div *ngSwitchCase="'MerchantCouponActions'">
                <button
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="'edit'"
                  [matTooltipPosition]="'above'"
                  (click)="merchantEditCouponset(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon fontIcon="edit"></mat-icon>
                </button>
              </div>

              <div
                *ngSwitchCase="
                  literalsFacade.literals.literals['liquid.merchant.summary.validfrom']
                "
                class="table-cell"
              >
                {{ matchRowWithColumn(element, column.value) | date: 'dd/MM/yyyy' }}
              </div>
              <div
                *ngSwitchCase="
                  literalsFacade.literals.literals['liquid.merchant.summary.validuntil']
                "
                class="table-cell"
              >
                {{ matchRowWithColumn(element, column.value) | date: 'dd/MM/yyyy' }}
              </div>

              <div *ngSwitchCase="'ClubActive'">
                <mat-icon
                  [matTooltip]="
                    element.deleteFlag
                      ? literalsFacade.literals.literals['liquid.club.inactiveclub']
                      : literalsFacade.literals.literals['liquid.club.activeclub']
                  "
                  [ngClass]="{
                    active: !element.deleteFlag,
                    inactive: element.deleteFlag,
                  }"
                  >fiber_manual_record</mat-icon
                >
              </div>

              <div *ngSwitchCase="'Clubs ' + this.clubLiteralsFacade.startDate">
                {{ matchRowWithColumn(element, column.value) | date: 'dd/MM/yyyy' }}
              </div>

              <div *ngSwitchCase="'End date'">
                {{ matchRowWithColumn(element, column.value) | date: 'dd/MM/yyyy' }}
              </div>

              <div *ngSwitchCase="'Default discount amount'">
                <div *ngIf="element.defaultDiscountAmount">
                  {{ matchRowWithColumn(element, column.value) }}
                </div>
                <div *ngIf="!element.defaultDiscountAmount">-</div>
              </div>

              <div *ngSwitchCase="'Default discount percentage (%)'">
                <div *ngIf="element.defaultDiscountPercentage">
                  {{ matchRowWithColumn(element, column.value) }}%
                </div>
                <div *ngIf="!element.defaultDiscountPercentage">-</div>
              </div>

              <div *ngSwitchCase="'ClubActions'">
                <button
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="'Edit'"
                  [matTooltipPosition]="'above'"
                  (click)="editData(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon class="merchant">edit</mat-icon>
                </button>
                <button
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="
                    element.deleteFlag
                      ? literalsFacade.literals.literals['liquid.club.activateclub']
                      : literalsFacade.literals.literals['liquid.club.deactivateclub']
                  "
                  [matTooltipPosition]="'above'"
                  (click)="deactivateClub(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon
                    [ngClass]="{
                      'club-active': !element.deleteFlag,
                      'club-inactive': element.deleteFlag,
                    }"
                    >power_settings_new</mat-icon
                  >
                </button>
              </div>

              <div
                *ngSwitchCase="
                  this.literalsFacade.literals.literals['liquid.integrations.integrationtype']
                "
              >
                <div>
                  <img
                    class="image-integration"
                    [src]="
                      'assets/img/dragonfly/integrations/' +
                      element.integrationConfig.integrationSystem +
                      '_Logo-Horizontal.png '
                    "
                    alt="type system logo"
                  />
                </div>
              </div>

              <div
                *ngSwitchCase="
                  this.literalsFacade.literals.literals['system.coupon.checkbookgivendate']
                "
                class="table-cell"
              >
                <div class="date-text" *ngIf="element[column.value]">
                  {{ element[column.value].split('T')[0] | date: 'dd-MM-yyyy' }}
                </div>
              </div>

              <div *ngSwitchCase="cmLiterals.tableCountry" class="table-cell">
                {{ matchCEIDwithCountry(element, column.value) }}
              </div>

              <div
                *ngSwitchCase="'CampaignSearch ' + campaignSearchLiterals.campaignSchema"
                class="table-cell"
              >
                {{ matchIDwithSchemaCampaignSearch(element, column.value) }}
              </div>

              <div
                *ngSwitchCase="'CampaignSearch ' + campaignSearchLiterals.campaignCountry"
                class="table-cell"
              >
                {{ matchCEIDwithCountryCampaignSearch(element, column.value) }}
              </div>

              <div
                *ngSwitchCase="'CampaignSearch ' + campaignSearchLiterals.campaignCategory"
                class="table-cell"
              >
                {{ matchCEIDwithCategoryCampaignSearch(element, column.value) }}
              </div>

              <div
                *ngSwitchCase="'CampaignSearch ' + campaignSearchLiterals.campaignStatus"
                class="table-cell"
              >
                {{ element.data.campaignStatus | removeUnderscores }}
              </div>

              <div
                *ngSwitchCase="'CampaignSearch ' + campaignSearchLiterals.campaignChannel"
                class="table-cell"
              >
                {{ element.data.campaignExecutionConfig.communicationChannel | removeUnderscores }}
              </div>

              <div
                *ngSwitchCase="'CampaignSearch ' + campaignSearchLiterals.campaignTarget"
                class="table-cell"
              >
                {{ element.data.campaignSelectionTarget | targetGroup }}
              </div>

              <div *ngSwitchCase="campaignSearchLiterals.campaignActiveFrom" class="table-cell">
                {{ matchRowWithColumnCampaignSearch(element, column.value) | date: 'dd/MM/yyyy' }}
              </div>
              <div *ngSwitchCase="campaignSearchLiterals.campaignActiveUntil" class="table-cell">
                {{ matchRowWithColumnCampaignSearch(element, column.value) | date: 'dd/MM/yyyy' }}
              </div>

              <div *ngSwitchCase="'CampaignSearchStatus'">
                <mat-icon
                  [matTooltip]="campaignSearchStatus(element)"
                  [ngClass]="{
                    active: !element.expired && !element.deleteFlag,
                    inactive: element.deleteFlag,
                    expired: element.expired && !element.deleteFlag,
                  }"
                  >fiber_manual_record</mat-icon
                >
              </div>

              <div *ngSwitchCase="cmLiterals.schema" class="table-cell">
                {{ matchCEIDwithSchema(element, column.value) }}
              </div>

              <div *ngSwitchCase="cmLiterals.date" class="table-cell">
                {{ element[column.value] | date: 'dd/MM/yyyy HH:mm:ss' }}
                <button
                  mat-flat-button
                  class="table-gray-button table-gray-button-padded"
                  [matTooltip]="'Edit Date'"
                  [matTooltipPosition]="'above'"
                  (click)="
                    editData(element, column.key, column.value); stopRowDataFlow($event, element)
                  "
                >
                  <mat-icon>edit</mat-icon>
                </button>
              </div>

              <div *ngSwitchCase="cmLiterals.tableCost" class="table-cell">
                {{ element[column.value] }}
                <button
                  mat-flat-button
                  class="table-gray-button table-gray-button-padded"
                  [matTooltip]="'Edit Cost'"
                  [matTooltipPosition]="'above'"
                  (click)="
                    editData(element, column.key, column.value); stopRowDataFlow($event, element)
                  "
                >
                  <mat-icon>edit</mat-icon>
                </button>
              </div>

              <div *ngSwitchCase="'CampaignExecutions'" class="table-cell">
                <button
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="'Download Recipients'"
                  [matTooltipPosition]="'above'"
                  (click)="
                    editData(element, column.key, column.value); stopRowDataFlow($event, element)
                  "
                >
                  <mat-icon fontIcon="save_alt" class="download-icon"></mat-icon>
                </button>
                <div [matTooltip]="'Canceled'" [matTooltipDisabled]="!element.canceled">
                  <button
                    *ngIf="element.progressPercentage !== '100%' || element.canceled"
                    mat-flat-button
                    class="table-gray-button"
                    [matTooltip]="'Cancel Execution'"
                    [matTooltipPosition]="'above'"
                    [disabled]="element.canceled"
                    (click)="cancelCampaignExecution(element); stopRowDataFlow($event, element)"
                  >
                    <mat-icon
                      fontIcon="clear"
                      class="download-icon"
                      [ngClass]="{
                        'text-active': element.canceled,
                        'text-inactive': !element.canceled,
                      }"
                    ></mat-icon>
                  </button>
                </div>
              </div>

              <div *ngIf="eliquaFacadeService.activeComponent === 'SearchCheckbooksComponent'">
                <div
                  *ngSwitchCase="
                    this.literalsFacade.literals.literals['liquid.coupon.filters.given']
                  "
                >
                  <mat-icon
                    *ngIf="element.given"
                    class="green-check"
                    [matTooltip]="literalsFacade.literals.literals['system.coupon.isgiven']"
                    >check</mat-icon
                  >

                  <mat-icon
                    *ngIf="!element.given"
                    class="red-close-btn"
                    [matTooltip]="literalsFacade.literals.literals['system.coupon.isnotgiven']"
                    >close</mat-icon
                  >
                </div>
              </div>

              <div *ngSwitchCase="'SchemasActive'">
                <mat-icon
                  [matTooltip]="element.deleteFlag ? 'Schema not active' : 'Schema active'"
                  [ngClass]="{
                    active: !element.deleteFlag,
                    inactive: element.deleteFlag,
                  }"
                  >fiber_manual_record</mat-icon
                >
              </div>

              <div *ngSwitchCase="schemasLiterals.company">
                {{ matchSchemaCompanyIdName(element) }}
              </div>

              <div *ngSwitchCase="schemasLiterals.printedCards">
                <mat-icon
                  fontIcon="fiber_manual_record"
                  [matTooltip]="
                    element.usesPrintedCards ? 'Uses Printed Cards' : 'Does not use Printed Cards'
                  "
                  [ngClass]="{
                    active: element.usesPrintedCards,
                    inactive: !element.usesPrintedCards,
                  }"
                ></mat-icon>
              </div>

              <div *ngSwitchCase="schemasLiterals.invoices">
                <mat-icon
                  fontIcon="fiber_manual_record"
                  [matTooltip]="element.usesInvoices ? 'Uses Invoices' : 'Does not use Invoices'"
                  [ngClass]="{
                    active: element.usesInvoices,
                    inactive: !element.usesInvoices,
                  }"
                ></mat-icon>
              </div>

              <div *ngSwitchCase="'SchemasActions'">
                <button
                  mat-flat-button
                  class="table-gray-button"
                  (click)="
                    editData(element, column.key, column.value); stopRowDataFlow($event, element)
                  "
                >
                  <mat-icon fontIcon="edit"></mat-icon>
                </button>
              </div>

              <div *ngSwitchCase="'CardBatchesActions'">
                <button
                  mat-flat-button
                  class="table-gray-button"
                  matTooltip="Download"
                  [matTooltipPosition]="'above'"
                  (click)="editData(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon fontIcon="download"></mat-icon>
                </button>
              </div>

              <div *ngSwitchCase="'CardBatches_CreationDate'" class="table-cell">
                {{ element[column.value] ? (element[column.value] | date: 'dd-MM-yyyy') : '-' }}
              </div>

              <div *ngSwitchCase="'CardBatches_PrintDate'" class="table-cell">
                {{ element[column.value] ? (element[column.value] | date: 'dd-MM-yyyy') : '-' }}
              </div>

              <div *ngSwitchCase="'RR,Discount'">
                <span *ngIf="element[column.value] !== null && element[column.value] !== undefined"
                  >{{ element[column.value] }}%</span
                >
                <span *ngIf="element[column.value] === null || element[column.value] === undefined"
                  >-</span
                >
              </div>

              <div *ngSwitchCase="'RR,Book Coupon Group'">
                {{ element[column.value] ? element[column.value] : '-' }}
              </div>

              <div *ngSwitchCase="'RR,Coupon Set'">
                {{ element[column.value] ? element[column.value] : '-' }}
              </div>

              <div *ngSwitchCase="'RR,Amount'">
                <span
                  *ngIf="element[column.value] !== null && element[column.value] !== undefined"
                  >{{ element[column.value] }}</span
                >
                <span *ngIf="element[column.value] === null || element[column.value] === undefined"
                  >-</span
                >
              </div>

              <div *ngSwitchCase="'RR,Currency'">
                {{ element[column.value] ? element[column.value] : '-' }}
              </div>

              <div *ngSwitchCase="'RR,Message'">
                {{ element[column.value] ? element[column.value] : '-' }}
              </div>

              <div *ngSwitchCase="'RR,Member Category'">
                {{ element[column.value] ? element[column.value] : '-' }}
              </div>

              <div *ngSwitchCase="'RR,Member Status'">
                {{ element[column.value] ? element[column.value] : '-' }}
              </div>

              <div *ngSwitchCase="'RR,Member Tag'">
                {{ element[column.value] ? element[column.value] : '-' }}
              </div>

              <div *ngSwitchCase="'RedeemRulesActions'">
                <button
                  mat-flat-button
                  class="table-gray-button"
                  matTooltip="Edit"
                  [matTooltipPosition]="'above'"
                  (click)="
                    editData(element, column.key, column.value); stopRowDataFlow($event, element)
                  "
                >
                  <mat-icon fontIcon="edit"></mat-icon>
                </button>
                <button
                  mat-flat-button
                  class="table-gray-button"
                  matTooltip="Delete"
                  [matTooltipPosition]="'above'"
                  (click)="deleteRedeemRule(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon fontIcon="delete"></mat-icon>
                </button>
              </div>

              <div *ngSwitchCase="'FlowRecipesActions'" class="table-cell">
                <button
                  *ngIf="!element.deleteFlag && rolesFacade.roles.roles['recipe.action.delete']"
                  mat-flat-button
                  class="table-gray-button"
                  (click)="deactivateRecipe(element)"
                >
                  <mat-icon fontIcon="power_settings_new" class="recipe-active"></mat-icon>
                </button>
                <button
                  *ngIf="element.deleteFlag && rolesFacade.roles.roles['recipe.action.update']"
                  mat-flat-button
                  class="table-gray-button"
                  (click)="activateRecipe(element)"
                >
                  <mat-icon fontIcon="power_settings_new" class="recipe-inactive"></mat-icon>
                </button>
                <button
                  *ngIf="rolesFacade.roles.roles['recipe.action.update']"
                  mat-flat-button
                  class="table-gray-button"
                  (click)="
                    editData(element, column.key, column.value); stopRowDataFlow($event, element)
                  "
                >
                  <mat-icon fontIcon="edit"></mat-icon>
                </button>
              </div>

              <div *ngIf="eliquaFacadeService.activeComponent === 'SearchCheckbooksComponent'">
                <div
                  *ngSwitchCase="
                    this.literalsFacade.literals.literals['system.checkbook.cardnumber']
                  "
                >
                  <div *ngIf="element[column.value]">
                    <a
                      class="checkbooks-link"
                      (click)="
                        getMeToMember(element.loyaltyMemberId); stopRowDataFlow($event, element)
                      "
                      >{{ element[column.value] }}</a
                    >
                  </div>
                </div>
              </div>

              <div *ngIf="eliquaFacadeService.activeComponent === 'SearchCheckbooksComponent'">
                <div *ngSwitchCase="'Checkbooks Actions'">
                  <button
                    mat-flat-button
                    class="table-gray-button"
                    (click)="
                      editData(element, column.key, column.value); stopRowDataFlow($event, element)
                    "
                  >
                    <mat-icon>visibility</mat-icon>
                  </button>
                  <button
                    mat-flat-button
                    *ngIf="searchCheckbooksFacadeService.showAssignBtn[index]"
                    class="table-gray-button"
                    (click)="assignCheckbook(); stopRowDataFlow($event, element)"
                  >
                    <mat-icon>person_add</mat-icon>
                  </button>
                  <button
                    mat-flat-button
                    *ngIf="searchCheckbooksFacadeService.showUnassignBtn[index]"
                    class="table-gray-button"
                    (click)="unassignCheckbook(); stopRowDataFlow($event, element)"
                  >
                    <mat-icon>person_remove</mat-icon>
                  </button>
                </div>
              </div>

              <div *ngIf="eliquaFacadeService.activeComponent === 'SearchGroupTemplatesComponent'">
                <div
                  *ngSwitchCase="
                    this.literalsFacade.literals.literals[
                      'liquid.checkbook.grouptemplate.redeempoints'
                    ]
                  "
                >
                  <mat-label>{{ element.redeemPoints ? element.redeemPoints : '-' }}</mat-label>
                </div>
              </div>

              <div *ngIf="eliquaFacadeService.activeComponent === 'SearchGroupTemplatesComponent'">
                <div
                  *ngSwitchCase="
                    this.literalsFacade.literals.literals['liquid.checkbook.grouptemplate.remarks']
                  "
                >
                  <mat-label>{{ element.remarks ? element.remarks : '-' }}</mat-label>
                </div>
              </div>

              <div *ngIf="eliquaFacadeService.activeComponent === 'SearchGroupTemplatesComponent'">
                <div
                  *ngSwitchCase="
                    this.literalsFacade.literals.literals[
                      'liquid.checkbook.grouptemplate.templatelinelist'
                    ]
                  "
                >
                  <mat-label>
                    {{
                      element.bookCouponGroupTemplateLineList?.length > 0
                        ? element.bookCouponGroupTemplateLineList.length + ' templates'
                        : '-'
                    }}
                  </mat-label>
                </div>
              </div>

              <div *ngIf="eliquaFacadeService.activeComponent === 'SearchGroupTemplatesComponent'">
                <div *ngSwitchCase="'Inactive Group Templates'">
                  <mat-icon
                    [ngClass]="{
                      active: !element.deleteFlag,
                      inactive: element.deleteFlag,
                    }"
                  >
                    fiber_manual_record
                  </mat-icon>
                </div>
              </div>

              <div *ngIf="eliquaFacadeService.activeComponent === 'SearchGroupTemplatesComponent'">
                <div *ngSwitchCase="'Group Templates Actions'">
                  <button
                    mat-flat-button
                    *ngIf="searchGroupTemplatesFacadeService.updateGroupTemplateRoleExist$ | async"
                    class="table-gray-button"
                    (click)="editData(element); stopRowDataFlow($event, element)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    *ngIf="searchGroupTemplatesFacadeService.updateGroupTemplateRoleExist$ | async"
                    mat-flat-button
                    class="table-gray-button"
                    (click)="changeRowStatus(element); stopRowDataFlow($event, element)"
                  >
                    <mat-icon
                      [ngClass]="{
                        'text-active': !element.deleteFlag,
                        'text-inactive': element.deleteFlag,
                      }"
                      >power_settings_new</mat-icon
                    >
                  </button>
                </div>
              </div>

              <div
                *ngSwitchCase="
                  this.literalsFacade.literals.literals['liquid.campaign.lists.listtarget']
                "
              >
                <div *ngIf="eliquaFacadeService.activeComponent === 'ListsComponent'">
                  <mat-label> {{ filterListsTarget(element, element[column.value]) }}</mat-label>
                </div>
              </div>

              <div *ngIf="eliquaFacadeService.activeComponent === 'ListsComponent'">
                <div *ngSwitchCase="'Lists Actions'">
                  <button
                    mat-flat-button
                    class="table-gray-button"
                    (click)="deleteRowData(element); stopRowDataFlow($event, element)"
                    [disabled]="element.listCount < 0"
                  >
                    <mat-icon class="delete-icon">delete_outline</mat-icon>
                  </button>
                  <button
                    *ngIf="rolesFacade.roles.roles['campaigns.adhoclists.export']"
                    mat-flat-button
                    class="table-gray-button"
                    (click)="downloadList(element); stopRowDataFlow($event, element)"
                    [disabled]="element.listCount <= 0"
                  >
                    <mat-icon class="download-list-icon">save_alt</mat-icon>
                  </button>
                  <button
                    mat-flat-button
                    class="table-gray-button"
                    (click)="showPreviewList(element); stopRowDataFlow($event, element)"
                    [disabled]="element.listCount <= 0"
                  >
                    <mat-icon>visibility</mat-icon>
                  </button>
                </div>
              </div>

              <div *ngIf="eliquaFacadeService.activeComponent === 'CampaignSearchComponent'">
                <div *ngSwitchCase="'CampaignSearchActions'" class="campaign-actions-container">
                  <button
                    mat-flat-button
                    class="table-gray-button"
                    *ngIf="rolesFacade.roles.roles['campaigns.action.update']"
                    (click)="campaignSearchUpdate(element)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    mat-flat-button
                    class="table-gray-button"
                    [disabled]="
                      element.data.campaignStatus === 'IN_DESIGN' ||
                      element.data.campaignStatus === 'NO_STATUS'
                    "
                    (click)="campaignSearchSend(element)"
                  >
                    <mat-icon>send</mat-icon>
                  </button>
                  <button
                    mat-flat-button
                    [matMenuTriggerFor]="campaignActionMenu"
                    class="table-gray-button"
                  >
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #campaignActionMenu="matMenu">
                    <button mat-menu-item (click)="campaignSearchNotes(element.data.campaignNotes)">
                      <mat-icon>notes</mat-icon>
                      <span>{{
                        literalsFacade.literals.literals['liquid.campaign.search.shownotes']
                      }}</span>
                    </button>
                    <button mat-menu-item (click)="showCampaignExecutionsPanel(element)">
                      <mat-icon>remove_red_eye</mat-icon>
                      <span>{{
                        literalsFacade.literals.literals['liquid.campaign.search.showexecutions']
                      }}</span>
                    </button>
                    <button mat-menu-item (click)="campaignSearchDuplicate(element)">
                      <mat-icon>content_copy</mat-icon>
                      <span>{{
                        literalsFacade.literals.literals['liquid.campaign.search.duplicate']
                      }}</span>
                    </button>
                    <button
                      *ngIf="element.deleteFlag"
                      mat-menu-item
                      (click)="campaignSearchActivationStatus(element)"
                    >
                      <mat-icon class="text-inactive">power_settings_new</mat-icon>
                      <span class="text-inactive">{{
                        literalsFacade.literals.literals['liquid.campaign.search.restore']
                      }}</span>
                    </button>
                    <button
                      *ngIf="!element.deleteFlag"
                      mat-menu-item
                      (click)="campaignSearchActivationStatus(element)"
                    >
                      <mat-icon class="text-active">power_settings_new</mat-icon>
                      <span class="text-active">{{
                        literalsFacade.literals.literals['liquid.campaign.search.delete']
                      }}</span>
                    </button>
                  </mat-menu>
                </div>
              </div>

              <div *ngSwitchCase="'SearchLiteralsActions'">
                <button
                  mat-flat-button
                  class="table-gray-button"
                  (click)="editData(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon class="merchant">edit</mat-icon>
                </button>
              </div>

              <div
                *ngSwitchCase="
                  literalsFacade.literals.literals['liquid.localestrings.lastchangedate']
                "
              >
                <div
                  *ngIf="eliquaFacadeService.activeComponent === 'ImportExportLiteralsComponent'"
                >
                  {{ element[column.value].split('T')[0] | date: 'dd-MM-yyyy' }}
                </div>
              </div>

              <div *ngSwitchCase="'Is New Literal'">
                <div
                  *ngIf="eliquaFacadeService.activeComponent === 'ImportExportLiteralsComponent'"
                >
                  {{
                    element.newLiteral
                      ? literalsFacade.literals.literals['liquid.localestrings.newliteral']
                      : element.editLiteral
                        ? literalsFacade.literals.literals['liquid.localestrings.futureliteral']
                        : ''
                  }}
                </div>
              </div>

              <div *ngSwitchCase="'Is Selected File'">
                <div
                  *ngIf="eliquaFacadeService.activeComponent === 'ImportExportLiteralsComponent'"
                >
                  <mat-checkbox
                    class="checkbox-integration"
                    [checked]="element.isSelectedLiteral"
                    (change)="checkedChange($event.checked, element.id)"
                  >
                  </mat-checkbox>
                </div>
              </div>

              <div *ngSwitchCase="ticketsLiterals.sortInitiationDate">
                {{ element[column.value].split('T')[0] | date: 'dd/MM/yyyy' }}
              </div>

              <div *ngSwitchCase="'Ticket' + this.ticketsLiterals.ticketStatus">
                {{ matchTicketStatus(element[column.value]) }}
              </div>

              <div *ngSwitchCase="ticketsLiterals.ticketAssignee">
                {{ matchTicketAssignee(element[column.value]) }}
              </div>

              <div *ngSwitchCase="ticketsLiterals.ticketSeverity">
                {{ matchTicketSeverity(element[column.value]) }}
              </div>

              <div *ngSwitchCase="ticketsLiterals.ticketCategory">
                {{ matchTicketCategory(element[column.value]) }}
              </div>

              <div *ngSwitchCase="ticketsLiterals.ticketLoyaltySchema">
                {{ matchTicketSchema(element[column.value]) || '-' }}
              </div>

              <div *ngSwitchCase="'TicketsActions'">
                <button
                  *ngIf="ticketsSearchFacade.canViewDetails$ | async"
                  mat-flat-button
                  class="table-gray-button"
                  (click)="openTicketSidenav(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon fontIcon="visibility"></mat-icon>
                </button>
                <button
                  mat-flat-button
                  class="table-gray-button"
                  (click)="ticketsRedirect(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon fontIcon="account_circle"></mat-icon>
                </button>
              </div>

              <div *ngSwitchCase="'FlowStatus'">
                <mat-icon
                  fontIcon="fiber_manual_record"
                  [ngClass]="{
                    active: !element.deleteFlag,
                    inactive: element.deleteFlag,
                  }"
                  matTooltipPosition="above"
                  [matTooltip]="element.deleteFlag ? 'Flow is deactivated' : 'Flow is active'"
                ></mat-icon>
              </div>

              <div *ngSwitchCase="'FlowActions'">
                <button
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="literalsFacade.literals.literals['liquid.flows.view']"
                  matTooltipPosition="above"
                  (click)="editFlow(element, true); stopRowDataFlow($event, element)"
                >
                  <mat-icon fontIcon="visibility"></mat-icon>
                </button>
                <button
                  *ngIf="
                    (searchFlowsFacade.updateRole$ | async) &&
                    hasTaskWithTemplateProperties(element)
                  "
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="literalsFacade.literals.literals['liquid.flows.editflow']"
                  matTooltipPosition="above"
                  (click)="editFlow(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon fontIcon="edit"></mat-icon>
                </button>
                <button
                  *ngIf="
                    (searchFlowsFacade.updateRole$ | async) &&
                    (searchFlowsFacade.updateAdvancedRole$ | async)
                  "
                  mat-flat-button
                  class="table-gray-button"
                  matTooltipPosition="above"
                  [matTooltip]="literalsFacade.literals.literals['liquid.flows.editflowadvanced']"
                  (click)="editFlow(element, false, true); stopRowDataFlow($event, element)"
                >
                  <mat-icon fontIcon="edit"></mat-icon>
                </button>
                <button
                  *ngIf="searchFlowsFacade.updateRole$ | async"
                  mat-flat-button
                  class="table-gray-button"
                  matTooltipPosition="above"
                  [matTooltip]="
                    element.deleteFlag
                      ? literalsFacade.literals.literals['liquid.flows.activateflow']
                      : literalsFacade.literals.literals['liquid.flows.deactivateflow']
                  "
                  (click)="deactivateFlow(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon
                    fontIcon="power_settings_new"
                    [ngClass]="{
                      'text-active': !element.deleteFlag,
                      'text-inactive': element.deleteFlag,
                    }"
                  ></mat-icon>
                </button>
              </div>

              <div *ngSwitchCase="'StoreStatus'">
                <mat-icon
                  [matTooltip]="
                    element.deleteFlag
                      ? (storeLiterals.isDeactivated$ | async)
                      : (storeLiterals.isActive$ | async)
                  "
                  [ngClass]="{
                    active: !element.deleteFlag,
                    inactive: element.deleteFlag,
                  }"
                  >fiber_manual_record</mat-icon
                >
              </div>

              <div *ngSwitchCase="'Store' + this.storeLiterals.storeName">
                <div class="store-language-names">
                  <div *ngFor="let store of element?.storeNames">
                    <div *ngIf="store?.languageCode === element?.selectedLanguageCode">
                      <div class="selected-row-store">{{ store.languageCode }}</div>
                    </div>
                    <div *ngIf="store?.languageCode !== element?.selectedLanguageCode">
                      <div
                        class="non-selected-row-store"
                        s
                        (click)="changeStoreRowLangCode(element.id, store.languageCode)"
                      >
                        {{ store.languageCode }}
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngFor="let store of element?.storeNames" class="store-language-names">
                  <div *ngIf="store?.languageCode === element?.selectedLanguageCode">
                    {{ store.name }}
                  </div>
                </div>
              </div>

              <div *ngSwitchCase="'StoreActions'">
                <button
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="storeLiterals.editStore$ | async"
                  matTooltipPosition="above"
                  (click)="editStore(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon
                    [fontIcon]="(storeFacade.tableCanUpdate$ | async) ? 'edit' : 'view'"
                  ></mat-icon>
                </button>
                <button
                  *ngIf="storeFacade.tableCanUpdate$ | async"
                  mat-flat-button
                  class="table-gray-button"
                  [matTooltip]="
                    !element.deleteFlag
                      ? (storeLiterals.deactivate$ | async)
                      : (storeLiterals.activate$ | async)
                  "
                  matTooltipPosition="above"
                  (click)="deactivateStore(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon
                    [class]="element.deleteFlag ? 'text-inactive' : 'text-active'"
                    fontIcon="power_settings_new"
                  ></mat-icon>
                </button>
              </div>

              <div
                *ngSwitchCase="'Customer' + this.literalsFacade.literals.literals['liquid.schema']"
                class="table-cell"
              >
                {{ matchCustomerWithSchema(element, column.value) }}
              </div>

              <div
                *ngSwitchCase="this.literalsFacade.literals.literals['liquid.customer.membersince']"
                class="table-cell"
              >
                {{ element[column.value].split('T')[0] | date: 'dd-MM-yyyy' }}
              </div>

              <div
                *ngSwitchCase="
                  this.literalsFacade.literals.literals['liquid.customer.registrationstore']
                "
                class="table-cell"
              >
                {{ matchCustomerWithStore(element, column.value) }}
              </div>

              <div *ngSwitchCase="'LMemberStatus'">
                <mat-icon
                  fontIcon="fiber_manual_record"
                  [ngClass]="{
                    active: !element.deleteFlag,
                    inactive: element.deleteFlag,
                  }"
                  [matTooltip]="element.deleteFlag ? 'Inactive' : 'Active'"
                  [matTooltipPosition]="'above'"
                ></mat-icon>
              </div>

              <div *ngSwitchCase="'CustomerActions'" class="table-cell">
                <button
                  mat-flat-button
                  class="table-gray-button"
                  matTooltipPosition="above"
                  (click)="viewMember(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon fontIcon="visibility"></mat-icon>
                </button>
                <button
                  *ngIf="lmFacade.editRole$ | async"
                  mat-flat-button
                  class="table-gray-button"
                  matTooltipPosition="above"
                  (click)="editMember(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon fontIcon="edit"></mat-icon>
                </button>
              </div>

              <div
                *ngSwitchCase="literalsFacade.literals.literals['system.person.birthdate']"
                class="table-cell"
              >
                {{ (matchRowWithColumn(element, column.value) | date: 'dd/MM/yyyy') || '-' }}
              </div>

              <div
                *ngSwitchCase="literalsFacade.literals.literals['liquid.system.namedaydate']"
                class="table-cell"
              >
                {{
                  element?.nameDayDay !== null && element?.nameDayMonth !== null
                    ? element?.nameDayDay + '/' + element?.nameDayMonth
                    : '-'
                }}
              </div>

              <div *ngSwitchCase="'ACStatus'">
                <mat-icon
                  fontIcon="fiber_manual_record"
                  [ngClass]="{
                    active: !element.deleteFlag,
                    inactive: element.deleteFlag,
                  }"
                  [matTooltip]="element.deleteFlag ? 'Inactive' : 'Active'"
                  [matTooltipPosition]="'above'"
                ></mat-icon>
              </div>

              <div *ngSwitchCase="'AllCustomerActions'" class="table-cell">
                <button
                  mat-flat-button
                  class="table-gray-button"
                  matTooltipPosition="above"
                  (click)="viewMember(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon fontIcon="visibility"></mat-icon>
                </button>
                <button
                  *ngIf="acFacade.editRole$ | async"
                  mat-flat-button
                  class="table-gray-button"
                  matTooltipPosition="above"
                  (click)="editMember(element); stopRowDataFlow($event, element)"
                >
                  <mat-icon fontIcon="edit"></mat-icon>
                </button>
              </div>

              <div *ngSwitchDefault>
                {{ matchRowWithColumn(element, column.value) || '-' }}
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="facade.displayedColumnKeys$ | async"></tr>

        <tr
          mat-row
          *matRowDef="let row; let even = even; columns: facade.displayedColumnKeys$ | async"
          [ngClass]="{ 'selected-row': facade.selectedId === row.id, 'even-row': even }"
          (click)="selectedRow(row)"
        ></tr>
      </table>
    </div>
    <div *ngIf="eliquaFacadeService.renderPaginator$ | async" class="paginator">
      <mat-paginator
        #paginator
        [showFirstLastButtons]="true"
        [hidePageSize]="true"
        [length]="paginatorFacade.totalResultPages$ | async"
        [pageSize]="paginatorFacade.itemsNumber$ | async"
        [pageIndex]="paginatorFacade.pageIndex$ | async"
        (page)="pagingChanged($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>
